import React from 'react';
import '../styles/History.css';

const History: React.FC = () => {
  return (
    <section id="history" className="section history-section">
      <div className="container">
        <div className="section-header">
          <h2>Understanding the Fork: KMDCL and KMD</h2>
          <p>Exploring the context and purpose of Komodo Classic in the broader blockchain ecosystem</p>
        </div>
        
        <div className="history-content">
          <div className="history-text">
            <h3>The Komodo Legacy</h3>
            <p>
              Komodo (KMD) began in 2014 under the leadership of James "jl777" Lee, evolving from a privacy-focused 
              cryptocurrency into a comprehensive blockchain platform. With roots in the Bitcoin and ZCash blockchains, 
              Komodo inherited powerful privacy features through zk-SNARK technology while adding innovative security 
              through its unique Delayed Proof of Work (dPoW) consensus mechanism.
            </p>
            <p>
              Over time, Komodo developed into an ecosystem supporting decentralized exchange capabilities, 
              custom blockchain creation, and interoperability solutions. However, as with many blockchain projects, 
              certain original features were modified or deprecated to accommodate new development directions.
            </p>
            
            <h3>The Purpose of Komodo Classic</h3>
            <p>
              In the world of cryptocurrencies, forks are a common way for communities to address different visions 
              and needs. Notable examples include Ethereum (ETH) and Ethereum Classic (ETC), as well as Bitcoin (BTC) 
              and Bitcoin Cash (BCH). When the Ethereum community faced a philosophical divide over immutability following 
              the DAO hack, Ethereum Classic emerged to preserve the original blockchain's principles. Similarly, Bitcoin 
              Cash forked from Bitcoin to implement larger block sizes for improved transaction throughput.
            </p>
            <p>
              Komodo Classic (KMDCL) follows this tradition, not in opposition to KMD, but as a complementary project 
              that preserves and enhances features valued by segments of the community. KMDCL aims to revive privacy 
              features, restore original economic parameters, and maintain the core principles that attracted many 
              early adopters to the Komodo ecosystem.
            </p>
          </div>
          
          <div className="comparison-container">
            <div className="comparison-card kmd">
              <h4>Komodo (KMD)</h4>
              <ul>
                <li>Focused on platform development and interoperability</li>
                <li>Reduced AUR from original 5%</li>
                <li>Modified block rewards per <a href="https://github.com/KomodoPlatform/kips/blob/main/kips/kip-0002.mediawiki" target="_blank" rel="noopener noreferrer">KIP-0002</a></li>
                <li>Disabled shielded transactions since 2019</li>
                <li>Emphasis on Smart Chain technology</li>
              </ul>
            </div>
            
            <div className="comparison-card kmdcl">
              <h4>Komodo Classic (KMDCL)</h4>
              <ul>
                <li>Restores original privacy features</li>
                <li>Maintains original 5% AUR</li>
                <li>Preserves 3 KMDCL block reward</li>
                <li>Implements replay attack protection</li>
                <li>1:1 distribution to KMD holders at fork</li>
                <li>Dedicated DEX for KMD/KMDCL trading</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
